var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Icon } from '@iconify/react';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, IconButton, ListItemIcon, ListItemSecondaryAction, ListItemText, Menu, MenuItem, Switch, Tab, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Add01Icon, Blockchain02Icon, BubbleChatIcon, Edit02Icon, LibraryIcon, Link05Icon, MessageQuestionIcon, MoreVerticalCircle01Icon, UserGroupIcon } from 'hugeicons-react';
import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { AppConsts } from '../../../application/common/constants/app-consts';
import { RoleCategories } from '../../../application/common/constants/role-categories';
import { getFilteredStringOperators } from '../../../application/common/helpers/grid-filter-operators';
import { useGetClientsListQuery } from '../../../application/features/clients/client-api';
import { setIsUpdateFolderGrid } from '../../../application/features/folder-view/folderViewSlice';
import { useGetMachineBrandListQuery, useGetMachinesListQuery, useGetPaginatedMachinesQuery } from '../../../application/features/machines/machine-api';
import { useAppDispatch, useAppSelector } from '../../../application/store/useStore';
import useTranslate from '../../../localization/helpers';
import FilterButton from '../../components/FilterButton';
import FindDocuments from '../../components/FindDocuments';
import FindMachine from '../../components/FindMachine';
import PageHeaderButton from '../../components/PageHeaderButton';
import ProtectedElement from '../../components/ProtectedElement';
import TableClickableItem from '../../components/tableClickableItem';
import { usePermissionGranted } from '../../hooks/usePermissionGranted';
import AiUserIcon from '../../icons/components/ai-user';
import { Permissions } from '../../permissions';
import FaqsDetails from '../faqs/faqs-details';
import AddMachine from './add-machine';
import AddMachineMobile from './add-machine/addMachineMobile';
import ClientsDrawer from './clients-drawer';
import EditMachine from './edit-machine';
import MachineCards from './machine-cards';
import MachineGrid from './machine-grid';
import MachineLibrary from './machine-library';
import ActivateMachineDialog from './machine-status/ActivateMachine';
import DeactivateMachineDialog from './machine-status/DeActivateMachine';
import Overview from './overview';
import TechniciansDrawer from './technicians-drawer';
var Machines = function (_a) {
    var _b;
    var initialTabValue = _a.initialTabValue, initialTabValueForGrid = _a.initialTabValueForGrid;
    var theme = useTheme();
    var dispatch = useAppDispatch();
    var location = useLocation();
    var _c = useTranslate(), translate = _c.translate, tWithFunction = _c.tWithFunction, currentLanguage = _c.currentLanguage;
    var isDutch = currentLanguage === 'nl';
    var navigate = useNavigate();
    var _d = __read(useSearchParams(), 1), searchParams = _d[0];
    var id = searchParams.get('id');
    var tabFromUrl = searchParams.get('tab');
    var tabForGridFromUrl = searchParams.get('tabGrid');
    var currentUser = useAppSelector(function (state) { return state.auth; }).currentUser;
    var currentCompany = useAppSelector(function (state) { return state.common; }).currentCompany;
    var _e = __read(useState(false), 2), isUpdateFolder = _e[0], setIsUpdateFolder = _e[1];
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var isSm = useMediaQuery(theme.breakpoints.only('sm'));
    var isMd = useMediaQuery(theme.breakpoints.only('md'));
    var isLg = useMediaQuery(theme.breakpoints.up('lg'));
    var isscreen600900 = useMediaQuery('(min-width:600px) and (max-width:900px)');
    var iscreen9001200 = useMediaQuery('(min-width:900px) and (max-width:1200px)');
    var isscreen9001200Landscape = useMediaQuery('(min-width:901px) and (max-width:1201px) and (orientation: landscape)');
    var isscreen600900Landscape = useMediaQuery('(min-width:600px) and (max-width:900px) and (orientation: landscape)');
    var isIpadMini = useMediaQuery('(max-width: 768px)');
    var isIpadMiniLandscape = useMediaQuery('(max-width: 1024px) and (orientation: landscape)');
    var _f = __read(useState(false), 2), openFilterDrawer = _f[0], setOpenFilterDrawer = _f[1];
    var clientPermissionsGranted = usePermissionGranted({
        permissions: [Permissions.Clients.Read]
    });
    var viewDocumentsPermissionsGranted = usePermissionGranted({
        permissions: [Permissions.Knowledge.Read]
    });
    var technicianPermissionsGranted = usePermissionGranted({
        permissions: [Permissions.Technicians.Read]
    });
    var _g = __read(useState(false), 2), addMachineModalOpen = _g[0], setAddMachineModalOpen = _g[1];
    var _h = __read(useState(false), 2), isFindMachineOpen = _h[0], setIsFindMachineOpen = _h[1];
    var _j = __read(useState(null), 2), anchorEl = _j[0], setAnchorEl = _j[1];
    var _k = __read(useState(null), 2), menuRowId = _k[0], setMenuRowId = _k[1];
    var _l = __read(useState(tabFromUrl || initialTabValue || 'Assets'), 2), tabValue = _l[0], setTabValue = _l[1];
    var _m = __read(useState(false), 2), findDocumentsModalOpen = _m[0], setFindDocumentsModalOpen = _m[1];
    var _o = __read(useState(null), 2), startChatMachineId = _o[0], setStartChatMachineId = _o[1];
    var _p = __read(useState({ isOpen: false }), 2), updateMachine = _p[0], setUpdateMachine = _p[1];
    var _q = __read(useState({ isOpen: false }), 2), clientsDrawer = _q[0], setClientsDrawer = _q[1];
    var _r = __read(useState({ isOpen: false }), 2), technicianDrawer = _r[0], setTechnicianDrawer = _r[1];
    var _s = __read(useState({ isOpen: false }), 2), faqDrawer = _s[0], setFAQDrawer = _s[1];
    var _t = __read(useState({
        id: id !== null && id !== void 0 ? id : undefined,
        clients: [],
        brands: [],
        machines: [],
        filterField: undefined,
        filterOperator: undefined,
        filterValue: undefined,
        sortField: AppConsts.DEFAULT_SORT_FIELD,
        sortDirection: AppConsts.DEFAULT_SORT_DIRECTION,
        page: AppConsts.DEFAULT_PAGE_NUMBER,
        pageSize: AppConsts.DEFAULT_PAGE_SIZE
    }), 2), machineFilters = _t[0], setMachineFilters = _t[1];
    var _u = __read(useState({ isOpen: false, isActive: false }), 2), machineStatusModal = _u[0], setMachineStatusModal = _u[1];
    var _v = useGetClientsListQuery().data, clientsList = _v === void 0 ? [] : _v;
    var _w = useGetMachinesListQuery({
        filterByCompany: true,
        isMachineLibrary: false
    }).data, machinesList = _w === void 0 ? [] : _w;
    var _x = useGetMachineBrandListQuery({ filterByCompany: true }).data, machinesBrandList = _x === void 0 ? [] : _x;
    var _y = useGetPaginatedMachinesQuery(machineFilters, {
        refetchOnMountOrArgChange: true
    }), data = _y.data, isFetching = _y.isFetching;
    var _z = (data !== null && data !== void 0 ? data : {}).items, machines = _z === void 0 ? [] : _z;
    var _0 = useForm({
        defaultValues: {
            clients: [],
            machines: []
        }
    }), control = _0.control, handleSubmit = _0.handleSubmit, reset = _0.reset, errors = _0.formState.errors;
    useEffect(function () {
        if (currentCompany) {
            setMachineFilters(function (prev) { return (__assign(__assign({}, prev), { clients: [], machines: [] })); });
        }
    }, [currentCompany]);
    var handleSortModelChange = function (model) {
        setMachineFilters(function (prev) {
            var _a, _b, _c, _d;
            return (__assign(__assign({}, prev), { sortField: (_b = (_a = model[0]) === null || _a === void 0 ? void 0 : _a.field) !== null && _b !== void 0 ? _b : AppConsts.DEFAULT_SORT_FIELD, sortDirection: (_d = (_c = model[0]) === null || _c === void 0 ? void 0 : _c.sort) !== null && _d !== void 0 ? _d : AppConsts.DEFAULT_SORT_DIRECTION }));
        });
    };
    var openMachineActivationModal = function (machine, isActive) {
        setMachineStatusModal({
            machine: machine,
            isOpen: true,
            isActive: isActive
        });
    };
    var closeMachineStatusModal = function () {
        setMachineStatusModal({
            isOpen: false,
            isActive: false
        });
    };
    var handlePaginationModelChange = function (model) {
        setMachineFilters(function (prev) { return (__assign(__assign({}, prev), { page: model.page + 1, pageSize: model.pageSize })); });
    };
    var activationModalOpen = machineStatusModal.isOpen && !machineStatusModal.isActive;
    var deActivationModalOpen = machineStatusModal.isOpen && machineStatusModal.isActive;
    var handleMenuClick = function (event, rowId) {
        setAnchorEl(event.currentTarget);
        setMenuRowId(rowId);
    };
    var handleTabChange = function (_event, newValue) {
        setTabValue(newValue);
    };
    var handleMenuClose = function () {
        setAnchorEl(null);
        setMenuRowId(null);
    };
    var handleFilterClick = function () {
        setOpenFilterDrawer(function (prev) { return !prev; });
    };
    var handleOpenFindMachine = function () { return setIsFindMachineOpen(true); };
    var handleOpenAddMachine = function () { return setAddMachineModalOpen(true); };
    var handleOpenEditMachine = function (e) { return setUpdateMachine({ id: e === null || e === void 0 ? void 0 : e.id, isOpen: true }); };
    var onViewDocuments = function (machineId) { return navigate("/knowledge?machine-id=".concat(machineId)); };
    var onManageSerialNumbers = function (machineId, tabGrid) {
        return navigate("/assets/serial-numbers/".concat(machineId, "?tabGrid=").concat(tabGrid));
    };
    var _1 = __read(useState(null), 2), openTooltipId = _1[0], setOpenTooltipId = _1[1];
    var onSearch = function (searchTerm) {
        var filterArg = __assign(__assign({}, searchTerm), { sortField: machineFilters.sortField, sortDirection: machineFilters.sortDirection, page: machineFilters.page, pageSize: machineFilters.pageSize, clients: searchTerm.clients, brands: searchTerm.brands, machines: searchTerm.machines });
        setMachineFilters(filterArg);
    };
    var onStartChat = function (machineId) {
        setAnchorEl(null);
        setMenuRowId(null);
        setStartChatMachineId(machineId);
        setFindDocumentsModalOpen(true);
    };
    var rowCountRef = React.useRef((_b = data === null || data === void 0 ? void 0 : data.totalCount) !== null && _b !== void 0 ? _b : 0);
    var rowCount = useMemo(function () {
        if ((data === null || data === void 0 ? void 0 : data.totalCount) !== undefined) {
            rowCountRef.current = data === null || data === void 0 ? void 0 : data.totalCount;
        }
        return rowCountRef.current;
    }, [data === null || data === void 0 ? void 0 : data.totalCount]);
    var handleFilterModelChange = function (model) {
        if (model.items.length > 0) {
            var filterItem_1 = model.items[0];
            if (filterItem_1.operator !== 'isEmpty' &&
                filterItem_1.operator !== 'isNotEmpty' &&
                (filterItem_1.value === '' ||
                    (Array.isArray(filterItem_1.value) && filterItem_1.value.length === 0) ||
                    filterItem_1.value === undefined)) {
                setMachineFilters(function (prev) { return (__assign(__assign({}, prev), { filterField: undefined, filterOperator: undefined, filterValue: undefined })); });
            }
            else {
                setMachineFilters(function (prev) {
                    var _a;
                    return (__assign(__assign({}, prev), { filterField: filterItem_1.field, filterOperator: filterItem_1.operator, filterValue: (_a = filterItem_1.value) === null || _a === void 0 ? void 0 : _a.toString() }));
                });
            }
        }
        else {
            // When model.items is empty, clear all filters
            setMachineFilters(function (prev) { return (__assign(__assign({}, prev), { filterField: undefined, filterOperator: undefined, filterValue: undefined })); });
        }
        setFilterModel(model);
    };
    var _2 = __read(useState({
        items: []
    }), 2), filterModel = _2[0], setFilterModel = _2[1];
    var generateMachineColumns = function () {
        var filterableColumns = ['name', 'type', 'brand', 'companyName'];
        var keys = [
            'linkedFrom',
            'name',
            'type',
            'technicians',
            'totalClients',
            'processedDocuments',
            'brand'
        ];
        var headers = {
            linkedFrom: translate('assets.matchingAssets.linked') + '?',
            name: translate('common.name'),
            type: translate('assets.type'),
            technicians: translate('common.technicians'),
            totalClients: translate('common.clients'),
            processedDocuments: translate('common.documents'),
            brand: translate('assets.brand')
        };
        if ((currentUser === null || currentUser === void 0 ? void 0 : currentUser.roleCategory) === RoleCategories.SuperAdmin) {
            keys.push('companyName');
            headers['companyName'] = translate('common.company');
        }
        var baseColumns = __spreadArray([], __read(keys.map(function (key) { return (__assign(__assign(__assign({ field: key, headerName: headers[key] || key.charAt(0).toUpperCase() + key.slice(1), flex: isXs
                ? undefined
                : isMd
                    ? undefined
                    : isscreen600900
                        ? undefined
                        : isSm
                            ? 1
                            : key === 'linkedFrom'
                                ? 0.5
                                : 1, minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined, width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined, filterable: filterableColumns.includes(key) }, (filterableColumns.includes(key)
            ? { filterOperators: getFilteredStringOperators() }
            : {})), (key === 'linkedFrom'
            ? {
                renderHeader: function () { return (_jsx(Box, { display: 'flex', alignItems: 'center', gap: 0.5, children: _jsx(Link05Icon, { width: 24, height: 24 }) })); }
            }
            : {})), { renderCell: key === 'linkedFrom'
                ? function (params) { return (_jsx(_Fragment, { children: params.row.linkedFrom.length > 0 && (_jsx(Box, { display: 'flex', flexShrink: 0, alignItems: 'center', height: '100%', sx: { cursor: 'pointer' }, children: _jsx(Tooltip, { arrow: true, placement: 'right', open: openTooltipId === params.row.id, onOpen: function () { return setOpenTooltipId(params.row.id); }, onClose: function () { return setOpenTooltipId(null); }, slotProps: {
                                popper: { disablePortal: false }
                            }, title: _jsx(Box, { maxHeight: '150px', sx: { overflowY: 'auto' }, children: params.row.linkedFrom
                                    .filter(function (item, index, self) {
                                    return index ===
                                        self.findIndex(function (t) {
                                            return t.companyName === item.companyName &&
                                                t.modelNumber === item.modelNumber &&
                                                t.machineName === item.machineName;
                                        });
                                })
                                    .map(function (l, i, arr) { return (_jsxs(Box, { sx: {
                                        p: 1,
                                        color: 'white',
                                        minWidth: 180,
                                        borderBottom: i < arr.length - 1 ? '2px solid #919EAB33' : 'none'
                                    }, children: [_jsx(Box, { width: '20px', height: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '500px', bgcolor: theme.palette.grey[300], color: theme.palette.grey[800], mb: 0.5, children: _jsx(Typography, { variant: 'body2', fontWeight: 600, children: i + 1 }) }), _jsxs(Box, { sx: { display: 'flex', flexDirection: 'column', gap: '4px' }, children: [_jsxs(Box, { sx: { display: 'flex', gap: 1 }, children: [_jsx(Typography, { variant: 'caption', sx: { color: theme.palette.grey[400] }, children: translate('common.asset') + ':' }), _jsx(Typography, { variant: 'caption', sx: { color: theme.palette.common.white }, children: l.machineName })] }), _jsxs(Box, { sx: { display: 'flex', gap: 1 }, children: [_jsx(Typography, { variant: 'caption', sx: { color: theme.palette.grey[400] }, children: translate('common.company') + ':' }), _jsx(Typography, { variant: 'caption', sx: { color: theme.palette.common.white }, children: l.companyName })] }), _jsxs(Box, { sx: { display: 'flex', gap: 1 }, children: [_jsx(Typography, { variant: 'caption', sx: { color: theme.palette.grey[400] }, children: translate('assets.matchingAssets.model') + '#:' }), _jsx(Typography, { variant: 'caption', sx: { color: theme.palette.common.white }, children: l.modelNumber })] })] })] }, i)); }) }), children: _jsx(Link05Icon, { width: 24, height: 24 }) }) })) })); }
                : key === 'name'
                    ? function (params) { return (_jsx(Box, { display: 'flex', alignItems: 'center', gap: 2, marginTop: '14px', children: _jsx(Box, { display: 'flex', justifyContent: 'center', flexDirection: 'column', flex: 1, minWidth: 0, children: _jsx(Typography, { title: params.row.name, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', variant: 'body2', children: params.row.name }) }) })); }
                    : key === 'technicians'
                        ? function (params) { return (_jsx(Box, { my: 1.5, children: _jsx(TableClickableItem, { text: params.row.technicians }) })); }
                        : key === 'totalClients'
                            ? function (params) { return (_jsx(Box, { my: 1.5, children: _jsx(TableClickableItem, { text: params.row.totalClients }) })); }
                            : key === 'processedDocuments'
                                ? function (params) { return (_jsx(Box, { my: 1.5, children: _jsx(TableClickableItem, { text: params.row.processedDocuments +
                                            params.row.processingDocuments +
                                            params.row.unprocessableDocuments +
                                            params.row.failedDocuments, showTooltip: true, tooltipContent: _jsxs(Box, { display: 'flex', flexDirection: 'column', gap: 1, children: [_jsx(Box, { display: 'flex', gap: 1, children: _jsxs(Typography, { variant: 'caption', color: theme.palette.grey[400], children: [translate('common.processedDocuments'), ":", _jsxs(Typography, { variant: 'caption', color: theme.palette.common.white, children: ['', " ", params.row.processedDocuments] })] }) }), _jsx(Box, { display: 'flex', gap: 1, children: _jsxs(Typography, { variant: 'caption', color: theme.palette.grey[400], children: [translate('common.processingDocuments'), ":", _jsxs(Typography, { variant: 'caption', color: theme.palette.common.white, children: [' ', params.row.processingDocuments] })] }) }), _jsx(Box, { display: 'flex', gap: 1, children: _jsxs(Typography, { variant: 'caption', color: theme.palette.grey[400], children: [translate('common.unprocessableDocuments'), ":", _jsxs(Typography, { variant: 'caption', color: theme.palette.common.white, children: ['', " ", params.row.unprocessableDocuments] })] }) }), _jsx(Box, { display: 'flex', gap: 1, children: _jsxs(Typography, { variant: 'caption', color: theme.palette.grey[400], children: [translate('common.failedDocuments'), ":", _jsxs(Typography, { variant: 'caption', color: theme.palette.common.white, children: ['', " ", params.row.failedDocuments] })] }) })] }), tooltipPlacement: 'top' }) })); }
                                : undefined })); })), false);
        baseColumns.push({
            field: 'isActive',
            headerName: translate('common.active'),
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 1 : 0.5,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            filterable: false,
            renderCell: function (params) { return (_jsx(ProtectedElement, { permissions: [Permissions.Machines.Update], children: _jsx(Switch, { checked: params.row.isActive, onChange: function (e) { return openMachineActivationModal(params.row, !e.target.checked); } }) })); }
        });
        baseColumns.push({
            field: 'action',
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            headerName: '',
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 0.1 : 0.1,
            width: isXs ? 1 : isMd ? 1 : isscreen600900 ? 1 : undefined,
            renderCell: function (params) {
                var menuItems = [
                    {
                        text: translate('assets.startChat'),
                        icon: BubbleChatIcon,
                        color: theme.palette.text.primary,
                        onClick: function () { return onStartChat(params.row.id); },
                        divider: true,
                        disabled: params.row.processedDocuments === 0 || params.row.isActive === false,
                        permissions: []
                    },
                    {
                        text: translate('assets.viewTechnicians'),
                        icon: AiUserIcon,
                        color: theme.palette.text.primary,
                        onClick: function () {
                            handleMenuClose();
                            setTechnicianDrawer({ isOpen: true, machine: params.row });
                        },
                        divider: false,
                        permissions: [Permissions.Technicians.Read]
                    },
                    {
                        text: translate('assets.viewClients'),
                        icon: UserGroupIcon,
                        color: theme.palette.text.primary,
                        onClick: function () {
                            handleMenuClose();
                            setClientsDrawer({ isOpen: true, machine: params.row });
                        },
                        divider: false,
                        permissions: [Permissions.Clients.Read]
                    },
                    {
                        text: translate('assets.viewFAQs'),
                        icon: MessageQuestionIcon,
                        color: theme.palette.text.primary,
                        onClick: function () {
                            var _a;
                            handleMenuClose();
                            setFAQDrawer({ machineId: (_a = params.row.id) !== null && _a !== void 0 ? _a : undefined, isOpen: true });
                        },
                        divider: false,
                        permissions: [Permissions.Faqs.Read]
                    },
                    {
                        text: translate('assets.modelSerialDocs'),
                        icon: Blockchain02Icon,
                        color: theme.palette.text.primary,
                        onClick: function () {
                            handleMenuClose();
                            onManageSerialNumbers(params.row.id, 'grid');
                        },
                        divider: false,
                        permissions: [Permissions.Machines.Read]
                    },
                    {
                        text: translate('assets.viewDocuments'),
                        icon: LibraryIcon,
                        color: theme.palette.text.primary,
                        onClick: function () {
                            handleMenuClose();
                            onViewDocuments(params.row.id);
                        },
                        divider: true,
                        endIcon: (_jsx(Icon, { icon: 'eva:diagonal-arrow-right-up-fill', fontSize: 20, color: theme.palette.primary.main })),
                        disabled: params.row.isActive === false,
                        permissions: [Permissions.Knowledge.Read]
                    },
                    {
                        text: translate('actions.edit'),
                        icon: Edit02Icon,
                        color: theme.palette.text.primary,
                        onClick: function () {
                            handleOpenEditMachine(params.row);
                            handleMenuClose();
                        },
                        divider: false,
                        permissions: [Permissions.Machines.Update]
                    }
                ];
                return (_jsxs(Fragment, { children: [_jsx(IconButton, { size: 'medium', onClick: function (event) { return handleMenuClick(event, params.id); }, children: _jsx(MoreVerticalCircle01Icon, { width: 20, height: 20 }) }), _jsx(Menu, { anchorEl: anchorEl, open: menuRowId === params.id, onClose: handleMenuClose, anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'center'
                            }, transformOrigin: {
                                vertical: 'top',
                                horizontal: 'center'
                            }, children: menuItems.map(function (menuItem) {
                                var _a;
                                return (_jsx(Box, { children: _jsx(ProtectedElement, { permissions: menuItem.permissions, children: _jsxs(MenuItem, { disabled: menuItem.disabled, onClick: menuItem.onClick, divider: menuItem.divider, sx: { color: menuItem.color }, children: [_jsx(ListItemIcon, { children: _jsx(menuItem.icon, { fontSize: 20, color: menuItem.color }) }), _jsx(ListItemText, { sx: { pr: isDutch ? 2.5 : undefined }, children: menuItem.text }), _jsx(ListItemSecondaryAction, { sx: { top: '60%', left: isDutch ? '90%' : undefined }, children: (_a = menuItem.endIcon) !== null && _a !== void 0 ? _a : _jsx(_Fragment, {}) })] }, menuItem.text) }) }, menuItem.text));
                            }) })] }));
            }
        });
        return baseColumns;
    };
    var machinesColumns = generateMachineColumns();
    var handleDetails = function (field, machine) {
        if (field === 'technicians' && technicianPermissionsGranted) {
            setTechnicianDrawer({ isOpen: true, machine: machine });
        }
        else if (field === 'processedDocuments' && viewDocumentsPermissionsGranted) {
            onViewDocuments(machine.id);
        }
        else if (field === 'totalClients' && clientPermissionsGranted) {
            setClientsDrawer({ isOpen: true, machine: machine });
        }
    };
    useEffect(function () {
        if (id) {
            var assetId = searchParams.get('id');
            if (assetId)
                setMachineFilters(__assign(__assign({}, machineFilters), { id: assetId }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchParams]);
    var handleResetMachineFilter = function () {
        setMachineFilters({
            id: id !== null && id !== void 0 ? id : undefined,
            clients: [],
            brands: [],
            machines: [],
            filterField: undefined,
            filterOperator: undefined,
            filterValue: undefined,
            sortField: AppConsts.DEFAULT_SORT_FIELD,
            sortDirection: AppConsts.DEFAULT_SORT_DIRECTION,
            page: AppConsts.DEFAULT_PAGE_NUMBER,
            pageSize: AppConsts.DEFAULT_PAGE_SIZE
        });
    };
    return (_jsxs(Box, { sx: {
            padding: isXs ? '16px' : '8px',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative'
        }, children: [_jsxs(Box, { mb: { xs: 1, md: 2 }, display: 'flex', justifyContent: isXs || isscreen600900 || iscreen9001200 || isscreen600900Landscape ? 'space-between' : '', flexDirection: isXs ? 'column' : 'row', gap: 1, alignItems: 'center', children: [_jsxs(Box, { display: 'flex', alignItems: 'center', gap: 1, width: '100%', children: [_jsx(Typography, { variant: 'h3', color: '#009983', children: translate('common.assets') }), _jsxs(Box, { display: 'flex', flexDirection: 'row', gap: 1, children: [_jsx(ProtectedElement, { permissions: [Permissions.Machines.Create], children: _jsx(PageHeaderButton, { text: translate('actions.add'), icon: _jsx(Add01Icon, { size: isXs ? 17 : undefined }), size: isXs ? 'small' : 'medium', onClick: handleOpenAddMachine, variant: 'contained', color: 'primary', title: tWithFunction('actions.addFunction', 'common.asset') }) }), _jsx(PageHeaderButton, { text: isXs ? translate('assets.chatMachine') : translate('assets.startChat'), icon: _jsx(BubbleChatIcon, { size: isXs ? 17 : undefined }), size: isXs ? 'small' : 'medium', onClick: handleOpenFindMachine, variant: 'contained', color: 'primary', title: tWithFunction('actions.findFunction', 'common.asset') })] })] }), !isXs && !isIpadMini && !isIpadMiniLandscape && !isLg && (_jsx(FilterButton, { variant: 'soft', onClick: handleFilterClick }))] }), _jsx(Box, { sx: { width: '100%' }, children: _jsxs(TabContext, { value: tabValue, children: [_jsx(Box, { sx: {
                                display: 'flex',
                                justifyContent: 'flex-start',
                                marginLeft: isXs ? '0px' : '13px'
                            }, children: _jsxs(TabList, { onChange: handleTabChange, "aria-label": 'Assets tabs', children: [_jsx(Tab, { iconPosition: 'start', label: translate('assets.overview'), value: 'Overview' }), _jsx(Tab, { iconPosition: 'start', label: translate('common.assets'), value: 'Assets' }), _jsx(Tab, { iconPosition: 'start', label: translate('assets.assetLibrary'), value: 'AssetLibrary' })] }) }), _jsx(Box, { sx: { width: '100%' }, children: _jsx(TabPanel, { value: 'Overview', sx: { padding: isXs ? '0px' : '6px' }, children: _jsx(Box, { px: '10px', children: _jsx(Overview, {}) }) }) }), _jsx(Box, { sx: { width: '100%' }, children: _jsx(TabPanel, { value: 'Assets', sx: { padding: '6px' }, children: isXs || isIpadMini || isIpadMiniLandscape ? (_jsx(MachineCards, { control: control, handleSubmit: handleSubmit, reset: reset, errors: errors, onSearch: onSearch, machines: machines, machineFilters: machineFilters, setMachineFilters: setMachineFilters, onStartChat: onStartChat, setTechnicianDrawer: setTechnicianDrawer, setClientsDrawer: setClientsDrawer, setFAQDrawer: setFAQDrawer, onManageSerialNumbers: onManageSerialNumbers, onViewDocuments: onViewDocuments, handleOpenEditMachine: handleOpenEditMachine, openMachineActivationModal: openMachineActivationModal, isUpdateFolder: isUpdateFolder, location: location.pathname, resetMachineFilter: handleResetMachineFilter })) : (_jsx(MachineGrid, { isXs: isXs, isscreen600900Landscape: isscreen600900Landscape, isscreen9001200Landscape: isscreen9001200Landscape, isscreen600900: isscreen600900, iscreen9001200: iscreen9001200, initialTabValue: tabForGridFromUrl || initialTabValueForGrid, handleSubmit: handleSubmit, onSearch: onSearch, control: control, errors: errors, reset: reset, isFetching: isFetching, clientsList: clientsList, machinesList: machinesList, machinesBrandList: machinesBrandList, openFilterDrawer: openFilterDrawer, setOpenFilterDrawer: setOpenFilterDrawer, machines: machines, filterModel: filterModel, onFilterModelChange: handleFilterModelChange, machinesColumns: machinesColumns, handleDetails: handleDetails, machineFilters: machineFilters, rowCount: rowCount, handlePaginationModelChange: handlePaginationModelChange, handleSortModelChange: handleSortModelChange, onViewDocuments: onViewDocuments, onManageSerialNumbers: onManageSerialNumbers, onStartChat: onStartChat, setFAQDrawer: setFAQDrawer, setTechnicianDrawer: setTechnicianDrawer, setClientsDrawer: setClientsDrawer, handleOpenEditMachine: handleOpenEditMachine, openMachineActivationModal: openMachineActivationModal, isUpdateFolder: isUpdateFolder, location: location.pathname, resetMachineFilter: handleResetMachineFilter })) }) }), _jsx(Box, { sx: { width: '100%' }, children: _jsx(TabPanel, { value: 'AssetLibrary', sx: { padding: isXs ? '0px' : '6px' }, children: _jsx(MachineLibrary, { isXs: isXs, isScreen9001200: iscreen9001200, isscreen600900Landscape: isscreen600900Landscape, isscreen600900: isscreen600900, iscreen9001200: iscreen9001200, isscreen9001200Landscape: isscreen9001200Landscape, isSm: isSm, isMd: isMd, isLg: isLg, isIpadMini: isIpadMini, isIpadMiniLandscape: isIpadMiniLandscape, openFilterDrawer: openFilterDrawer, setOpenFilterDrawer: setOpenFilterDrawer }) }) })] }) }), addMachineModalOpen && !isXs && (_jsx(AddMachine, { onClose: function () { return setAddMachineModalOpen(false); }, open: addMachineModalOpen })), addMachineModalOpen && isXs && (_jsx(AddMachineMobile, { onClose: function () { return setAddMachineModalOpen(false); }, open: addMachineModalOpen })), updateMachine.isOpen && (_jsx(EditMachine, { onClose: function () { return setUpdateMachine({ isOpen: false }); }, open: updateMachine.isOpen, machineId: updateMachine === null || updateMachine === void 0 ? void 0 : updateMachine.id })), isFindMachineOpen && (_jsx(FindMachine, { isOpen: isFindMachineOpen, setIsOpen: setIsFindMachineOpen })), _jsx(ClientsDrawer, { isOpen: clientsDrawer.isOpen, machine: clientsDrawer.machine, onClose: function () { return setClientsDrawer({ isOpen: false }); } }), _jsx(TechniciansDrawer, { isOpen: technicianDrawer.isOpen, machine: technicianDrawer.machine, onClose: function () { return setTechnicianDrawer({ isOpen: false }); } }), findDocumentsModalOpen && startChatMachineId && (_jsx(FindDocuments, { isOpen: findDocumentsModalOpen, setIsOpen: setFindDocumentsModalOpen, machineId: startChatMachineId })), activationModalOpen && (_jsx(ActivateMachineDialog, { machine: machineStatusModal.machine, isOpen: activationModalOpen, onClose: closeMachineStatusModal, onUpdate: function (isUpdate) {
                    setIsUpdateFolder(isUpdate);
                    dispatch(setIsUpdateFolderGrid(true));
                } })), deActivationModalOpen && (_jsx(DeactivateMachineDialog, { machine: machineStatusModal.machine, isOpen: deActivationModalOpen, onClose: closeMachineStatusModal, onUpdate: function (isUpdate) {
                    setIsUpdateFolder(isUpdate);
                    dispatch(setIsUpdateFolderGrid(true));
                } })), faqDrawer.isOpen && faqDrawer.machineId && (_jsx(FaqsDetails, { isOpen: faqDrawer.isOpen, onClose: function () { return setFAQDrawer({ isOpen: false }); }, machineId: faqDrawer.machineId }))] }));
};
export default Machines;
